import { useState, useEffect } from 'react';
import { Truck, MapPin, Clock } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '@/lib/api';

export default function FarmPickups() {
  const [pickups, setPickups] = useState([]);
  const load = () => api.get('/farm/pickups').then((r) => setPickups(r.data.filter((p) => p.pickup_date))).catch(() => {});
  useEffect(() => { load(); }, []);
  const ready = async (id) => { await api.post(`/farm/orders/${id}/ready`); toast.success('Marked ready'); load(); };

  return (
    <div data-testid="farm-pickups">
      <p className="font-manrope text-dark/60 mb-6">Your upcoming FarmBox pickups. Mark orders ready so FarmBox knows they're prepared.</p>
      {pickups.length === 0 ? (
        <div className="bg-white rounded-2xl border border-forest/10 p-12 text-center font-manrope text-dark/50">No scheduled pickups yet.</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-5">
          {pickups.map((p) => (
            <div key={p.order_id} className="bg-white rounded-2xl border border-forest/10 p-6" data-testid={`pickup-${p.order_id}`}>
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2"><Truck className="w-5 h-5 text-forest" /><h3 className="font-playfair text-xl font-bold text-dark">{p.pickup_date}</h3></div>
                <span className={`px-3 py-1 rounded-full text-xs font-bold ${p.pickup_status === 'Picked Up' ? 'bg-dark/10 text-dark' : p.pickup_status === 'Ready for Pickup' ? 'bg-forest/10 text-forest' : 'bg-gold/15 text-gold-dark'}`}>{p.pickup_status}</span>
              </div>
              <p className="flex items-center gap-2 font-manrope text-sm text-dark/70"><Clock className="w-4 h-4 text-gold" />{p.pickup_window}</p>
              <p className="flex items-center gap-2 font-manrope text-sm text-dark/70 mt-1"><MapPin className="w-4 h-4 text-gold" />{p.pickup_address}</p>
              <div className="mt-3 space-y-1">{p.items.map((it) => <p key={it.product_id} className="font-manrope text-sm text-dark/60">{it.name} — {it.requested_quantity} {it.unit}</p>)}</div>
              <p className="font-playfair text-lg font-bold text-forest mt-3">Total ${p.total.toFixed(2)}</p>
              {p.pickup_status === 'Not Ready' && <button onClick={() => ready(p.order_id)} className="btn-primary py-2 px-5 text-sm mt-4" data-testid={`pickup-ready-${p.order_id}`}>Mark Ready for Pickup</button>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
